import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Hidden from '@material-ui/core/Hidden';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ConfirmDialog from './ConfirmDialog';

// Icons
import MenuIcon from '@material-ui/icons/Menu';
import HomeIcon from '@material-ui/icons/Home';
import EditIcon from '@material-ui/icons/Edit';
import LockIcon from '@material-ui/icons/Lock';
import AddUserIcon from '@material-ui/icons/PersonAdd';
import PaymentIcon from '@material-ui/icons/Payment';
import LogoutIcon from '@material-ui/icons/ExitToApp';
import EmailIcon from '@material-ui/icons/Email';
import ReceiptsIcon from '@material-ui/icons/Receipt';
import { GatewayAddIcon, GatewayReplaceIcon, GatewayTransferIcon } from '../Assets/Icons/Sikom';

let logout;
let t;
let self;

class MainMenu extends React.Component {
    constructor(props) {
        super(props);
        logout = props.logout;
        t = props.getTranslation;
        self = this;
    }


    state = {
        mobileOpen: false,
        currentPage: this.props.currentPage,
        showFillOutFormDialog: false
    };

 
    // We should not update the page if the user is currently editing a form
    updatePage = (page) => {
        if (this.props.menuIsClickable) {
            this.props.updatePage(page);
        }
    };

    handleDrawerToggle = () => {
        if (this.props.menuIsClickable) {
            this.setState(state => ({ mobileOpen: !state.mobileOpen }));
        } else {
            this.setState(state => ({ showFillOutFormDialog: true }));
        }
    };

    // Todo: Maybe the Confirm Dialog does not belong here in the menu class?
    getDialogTitleText() {
        return t('form_not_completed_title');
    }

    getDialogMessageText() {
        return t('form_not_completed_message');;
    }

    getDialogButtonText() {
        return t('ok');
    }

    onDialogButtonClicked = e => {
        e.preventDefault();
        this.setState(state => ({ showFillOutFormDialog: false }));
    }

    render() {
        const { classes, theme } = this.props;
        const drawer = (
            <div>
                <div className={classes.toolbar} />
                <Divider />
                <List>{menuItems(this.props.customerIsRegistered, this.handleDrawerToggle)}</List>
                <Divider />
                <List>{extraMenuItems()}</List>
            </div>
        );

        const fillOutFormDialog =
            <ConfirmDialog
                titleText={this.getDialogTitleText()}
                messageText={this.getDialogMessageText()}
                buttonText={this.getDialogButtonText()}
                onButtonClicked={e => this.onDialogButtonClicked(e)}
                open={this.state.showFillOutFormDialog} />

        return (
            <div className={classes.root}>
                {fillOutFormDialog}
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton
                            color="inherit"
                            aria-label="Open drawer"
                            onClick={this.handleDrawerToggle}
                            className={classes.navIconHide}
                        >
                            <MenuIcon />
                        </IconButton>
                        <Typography variant="title" color="inherit" noWrap>
                            {t(this.props.currentPage)}
                        </Typography>
                    </Toolbar>
                </AppBar>
                <Hidden mdUp>
                    <Drawer
                        variant="temporary"
                        anchor={theme.direction === 'rtl' ? 'right' : 'left'}
                        open={this.state.mobileOpen}
                        onClose={this.handleDrawerToggle}
                        classes={{
                            paper: classes.drawerPaper,
                        }}
                        ModalProps={{
                            keepMounted: true, // Better open performance on mobile.
                        }}
                    >
                        {drawer}
                    </Drawer>
                </Hidden>
                <Hidden smDown implementation="css">
                    <Drawer
                        variant="permanent"
                        open
                        classes={{
                            paper: classes.drawerPaper,
                        }}
                    >
                        {drawer}
                    </Drawer>
                </Hidden>
                <main className={classes.content}>
                    <div className={classes.toolbar} />
                    {
                        /*
                        * Custom content goes here!
                        * Currently getting entire content view from Main
                        * as props.
                        */
                    }
                    {this.props.content}
                </main>
            </div>
        );
    }
}

MainMenu.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};

const drawerWidth = 280;

const styles = theme => ({
    root: {
        flexGrow: 1,
        height: 430,
        zIndex: 1,
        position: 'relative',
        display: 'flex',
        width: '100%',
    },
    appBar: {
        position: 'fixed',
        marginLeft: drawerWidth,
        [theme.breakpoints.up('md')]: {
            width: `calc(100% - ${drawerWidth}px)`,
        },
    },
    navIconHide: {
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    toolbar: theme.mixins.toolbar,
    drawerPaper: {
        width: drawerWidth,
        [theme.breakpoints.up('md')]: {
            position: 'relative',
        },
    },
    content: {
        flexGrow: 1,
        //padding: theme.spacing.unit * 2,
        padding: 5,
    },
});

function menuItems(customerIsRegistered, toggleMenuFunction) {
    const registeredItems =
        <div>
            <ListItem button onClick={function () { toggleMenuFunction(); self.updatePage('edit_profile'); }}>
                <ListItemIcon>
                    <EditIcon />
                </ListItemIcon>
                <ListItemText primary={t('edit_profile')} />
            </ListItem>
            <ListItem button onClick={function () { toggleMenuFunction(); self.updatePage('change_email'); }}>
                <ListItemIcon>
                    <EmailIcon />
                </ListItemIcon>
                <ListItemText primary={t('change_email')} />
            </ListItem>
            <ListItem button onClick={function () { toggleMenuFunction(); self.updatePage('change_password'); }}>
                <ListItemIcon>
                    <LockIcon />
                </ListItemIcon>
                <ListItemText primary={t('change_password')} />
            </ListItem>
            <ListItem button onClick={function () { toggleMenuFunction(); self.updatePage('add_gateway'); }}>
                <ListItemIcon>
                    <GatewayAddIcon />
                </ListItemIcon>
                <ListItemText primary={t('add_gateway')} />
            </ListItem>
            <ListItem button onClick={function () { toggleMenuFunction(); self.updatePage('change_gateway_ownership'); }}>
                <ListItemIcon>
                    <GatewayTransferIcon />
                </ListItemIcon>
                <ListItemText primary={t('change_ownership')} />
            </ListItem>
            <ListItem button onClick={function () { toggleMenuFunction(); self.updatePage('replace_gateway'); }}>
                <ListItemIcon>
                    <GatewayReplaceIcon />
                </ListItemIcon>
                <ListItemText primary={t('replace_gateway')} />
            </ListItem>
        </div>;

    const notRegisteredItems =
        <div>
            <ListItem button onClick={function () { toggleMenuFunction(); self.updatePage('sign_up'); }}>
                <ListItemIcon>
                    <AddUserIcon />
                </ListItemIcon>
                <ListItemText primary={t('sign_up')} />
            </ListItem>
        </div>;

    const myMenuItems =
        <div>
            <ListItem button onClick={function () { toggleMenuFunction(); self.updatePage('account_overview'); }} >
                <ListItemIcon>
                    <HomeIcon />
                </ListItemIcon>
                <ListItemText primary={t('account_overview')} />
            </ListItem>
            {customerIsRegistered ? registeredItems : notRegisteredItems}
            <ListItem button onClick={function () { toggleMenuFunction(); self.updatePage('subscription'); }}>
                <ListItemIcon>
                    <PaymentIcon />
                </ListItemIcon>
                <ListItemText primary={t('subscription')} />
            </ListItem>
            <ListItem button onClick={function () { toggleMenuFunction(); self.updatePage('receipts'); }}>
                <ListItemIcon>
                    <ReceiptsIcon />
                </ListItemIcon>
                <ListItemText primary={t('receipts')} />
            </ListItem>
        </div>;
    return myMenuItems;
}


// These icons are found below a divider line. Currently only used for the logout button
function extraMenuItems() {
    // Hide logout button if we are coming from the phone app.
    if (self.props.automaticLogin === true) {
        return null;
    }

    const extraMenuItems = <div>
        <ListItem button onClick={() => logout()}>
            <ListItemIcon>
                <LogoutIcon />
            </ListItemIcon>
            <ListItemText primary={t('log_out')} />
        </ListItem>
    </div>;
    return extraMenuItems;
}

export default withStyles(styles, { withTheme: true })(MainMenu);


// WEBPACK FOOTER //
// ./src/Components/MainMenu.js